import { useLocation, useOutlet } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';

/**
 * AnimatedOutlet - Wraps React Router's Outlet with page transitions
 *
 * Uses Framer Motion to provide smooth fade + slide transitions between pages.
 * The key prop ensures AnimatePresence tracks route changes correctly.
 *
 * Created: 2026-02-05 (GAP-UX-007)
 */

export function AnimatedOutlet() {
  const location = useLocation();
  const element = useOutlet();

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -12 }}
        transition={{ duration: 0.2, ease: 'easeInOut' }}
      >
        {element}
      </motion.div>
    </AnimatePresence>
  );
}
